<!--详情页面-->
<template>
  <el-dialog
    :title="pagetitle.indexOf(';')!=-1?pagetitle.split(';')[0]:pagetitle"
    :visible.sync="dialogSeeVisible"
    center
    :close-on-click-modal="false" :append-to-body="true"
    custom-class="medium-dialog">
    <div ref="print1" style="width: 100%;margin: 0 auto;">
      <div :style="{display:showtitle1,textAlign:'center',fontSize:'26px',lineHeight:'40px'}">
        {{pagetitle.indexOf(';')!=-1?pagetitle.split(';')[0]:pagetitle}}
      </div>
      <div style="width: 100%;float: left;">
        <div style="width: 220px;float: left;margin-top: 15px;margin-left: 10px">NO：{{controlData.erpserial?controlData.erpserial.split('-')[0]:""}}</div>
      <div style="width: 220px;float: right;"><img id="csteditbarcode"/></div>
      </div>
      <table cellspacing="0" cellpadding="0" border="0"
             class="print-table"  :style="picture()">
        <tr class="noborder" style="height:26px">
          <td align="right"  width="60">客&nbsp;&nbsp;户：</td>
          <td width="150" v-if="!ismachineprint">{{controlData.customername}} {{controlData.linkmantel||""}}</td>
          <td width="150" v-else>&nbsp;</td>
          <td align="right" width="60">时&nbsp;&nbsp;间：</td>
          <td  width="150">{{controlData.htqd||controlData.adddate}}</td>
          <!--<td align="right">出&nbsp;&nbsp;&nbsp;&nbsp;库：</td>-->
          <!--<td>{{controlData.handleoverdate}}</td>-->
          <td align="right" width="60" >&nbsp;</td>
          <td>&nbsp;</td>
        </tr>
        <tr class="noborder" style="height:26px" v-if="!isprint">
          <td align="right" width="60" ><span>仓&nbsp;&nbsp;库：</span></td>
          <td v-if="status>=350&&btn!='填写发货单'" colspan="3"><span>{{controlData.cangkuname}}</span>
            <span  class="no-print" style="color: blue;cursor:pointer;margin-left: 10px"
              @click="updatecangku(controlData)"
              v-if="status==350&&controlData.isreturnorder!=-1&&isShowAdressAndCangkuUpdate">修改</span>
          </td>
          <td v-if="btn=='填写发货单'" >
            <span v-if="!isprint">{{getCangkuNameByCode(form.cangkucode)}}
            </span>
          </td>
          <!--<td align="right">地&nbsp;&nbsp;址：</td>-->
          <!--<td>{{controlData.deliveryaddress}}<span-->
            <!--class="no-print" style="color: blue;cursor:pointer;margin-left: 10px"-->
            <!--v-if="controlData.status<500&&controlData.isreturnorder!=-1&&isShowAdressAndCangkuUpdate"-->
            <!--@click="updateaddress">修改</span></td>-->
          <td align="right" v-if="buyinfo&&buyinfo.erpserial" class="no-print">采购单：</td>
          <td v-if="buyinfo&&buyinfo.erpserial" class="no-print">
            {{(buyinfo?buyinfo.erpserial:'')}}<br>
            {{(buyinfo&&parseFloat(buyinfo.status)==810?'待收货':(parseFloat(buyinfo.status)==805?'已作废':'已收货'))}}
          </td>
        </tr>
        <tr class="noborder" style="height:26px" v-if="!ismachineprint">
          <!--<td align="right">运&nbsp;&nbsp;费：</td>-->
          <!--<td>￥{{controlData.expressfee+" "+controlData.deliverymode}}</td>-->
          <!--<td align="right" v-if="controlData.machinecstagreementDO&&controlData.machinecstagreementDO.unitguid">加工单：-->
          <!--</td>-->
          <td colspan="6"><span style="font-size:14px;font-weight: bolder" v-html="priceSuminfo"></span>
          <span style="float: right"> {{paymethod}}</span></td>
        </tr>
        <tr class="noborder no-print" v-show="status==350&&btn=='填写发货单'" style="height:26px">
          <td align="right">物&nbsp;&nbsp;流：</td>
          <td>
            <el-select v-if="!isprint" v-model="form.logisticsco" placeholder="请选择" style="width: 125px;" size="mini">
              <el-option
                v-for="item in parameterData"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
            <span v-if="isprint">{{form.logisticsco}}</span>
          </td>
          <td align="right">快递号：</td>
          <td>
            <el-input v-if="!isprint" v-model="logisticsnumPre" auto-complete="off" required="true" size="mini"
                      style="width: 135px;" placeholder="请填写快递单号"></el-input>
            <span v-if="!isprint&&form.logisticsco.indexOf('顺丰')>-1">
            <el-input v-model="logisticsnumEnd" auto-complete="off" required="true" size="mini" style="width: 135px;"
                      placeholder="寄件人手机号后4位"></el-input>
            </span>
            <span v-if="isprint">{{form.logisticsnum}}</span>
          </td>
          <td align="right">发货时：</td>
          <td>{{btn=='填写发货单'?formatTime():controlData.handleoverdate}}</td>
        </tr>
        <tr class="noborder no-print" v-show="status<650 && status>350" style="height:26px">
          <td align="right">物 &nbsp; 流：</td>
          <td>{{controlData.logisticsco}}</td>
          <td align="right">快递号：</td>
          <td>{{controlData.logisticsnum}}</td>
          <td align="right">发货时：</td>
          <td>{{btn=='填写发货单'?formatTime():controlData.handleoverdate}}</td>
        </tr>
        <tr class="noborder" v-show="isshowyuandd" style="font-weight:bold;cursor:pointer"
            @click="lookDetails(controlData.sycstagreementDO)">
          <td align="right">原订单：</td>
          <td>{{controlData.sycstagreementDO.erpserial}}</td>
          <td align="right">时 &nbsp;间：</td>
          <td>{{controlData.sycstagreementDO.adddate}}</td>
          <td align="right">状 &nbsp;态：</td>
          <td v-if="controlData.sycstagreementDO.status">{{controlData.sycstagreementDO.status}}
            <span style="color:red">{{controlData.sycstagreementDO.paymethod||''}}</span>
          </td>
        </tr>
        <tr v-if="isreturnorderEidt" class="noborder" style="font-weight:bold">
          <td align="right">退货原因</td>
          <td>
            <el-select v-model="controlData.returntype" placeholder="请选择" style="width: 135px;" size="mini"
                       @change="changereturntype">
              <el-option
                v-for="item in tuihuoyy"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
          </td>
          <td colspan="4">
            <el-input type="textarea" v-model="remark" :autosize="{ minRows: 1, maxRows: 1}"/>
          </td>
        </tr>
        <tr class="noborder" v-show="!isprint&&(status==350&&btn=='填写发货单')">
          <td align="right">商品码：</td>
          <td>
            <el-input v-model="goodsbarcode" size="mini" @keyup.enter.native="selectbarcode" ref="inputScan" onfocus="this.select()" style="width: 125px"></el-input>
          </td>
          <td align="right"></td>
          <td></td>
          <td align="right"></td>
          <td></td>
        </tr>
        <tr>
          <td colspan="6" style="border:none">
            <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;" class="query-table">
              <tr>
                <td style="text-align: center;width: 50px">R/L</td>
                <td style="text-align: center;min-width: 90px">产品名称</td>
                <td style="text-align: center;min-width: 50px" v-for="col in columnarr" :key="col.name" v-if="col.show">{{col.name}}</td>
                <td style="text-align: center;min-width: 50px">数量</td>
                <td v-if="printDisplay&&!ismachineprint&&tableShowData.length>0" style="text-align: center;min-width: 70px">原价
                </td>
                <td v-if="printDisplay&&!ismachineprint&&tableShowData.length>0" style="text-align: center;min-width: 70px">实售价
                </td>
              </tr>
              <!--表头结束-->
              <tr v-for="item in tableShowData">
                <td style="text-align: center">{{item["RL"]}}</td>
                <td>{{item["产品名称"]}}</td>
                <td v-for="col in columnarr" :key="col.name" v-if="col.show">{{item[col.name]}}</td>
                <td style="text-align: center">{{item["数量"]}}<span v-if="item.scannum&&item.scannum>0" style="font-size: large;color: red"><b> / {{item["scannum"]}}</b></span></td>
                <td v-if="printDisplay&&!ismachineprint&&tableShowData.length>0" style="text-align: center">
                  {{parseFloat(item['单价']||0).toFixed(2)}}
                </td>
                <td v-if="printDisplay&&!ismachineprint&&tableShowData.length>0" style="text-align: center">
                  {{parseFloat(item['总价']||0).toFixed(2)}}
                </td>
              </tr>
              <!--表内容行结束-->
              <tr >
                <td></td>
                <td style="text-align: center">合计</td>
                <td style="text-align: center" v-for="col in columnarr" :key="col.name" v-if="col.show"></td>
                <td style="text-align: center">{{totalnumber}}</td>
                <td v-if="printDisplay&&!ismachineprint&&tableShowData.length>0" style="text-align: center">{{salemoney.toFixed(2)}}</td>
                <td v-if="printDisplay&&!ismachineprint&&tableShowData.length>0" style="text-align: center">{{totalmoney.toFixed(2)}}</td>
              </tr>
            </table>
            <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;margin-top: 5px" v-if="form.scancodes&&form.scancodes.length>0&&form.scancodes[0].batchno"
                   class="query-table">
              <tr>
                <td style="text-align: center;min-width: 120px">产品名称</td>
                <td style="text-align: center;min-width: 50px">批次号</td>
                <td style="text-align: center;min-width: 50px">有效期</td>
                <td style="text-align: center;min-width: 50px">证号</td>
                <td style="text-align: center;min-width: 50px">厂家</td>
              </tr>
              <!--表头结束-->
              <tr v-for="item in form.scancodes">
                <td> {{item.seedname}} {{item.packagesize?(JSON.parse(item.packagesize).Y):''}}</td>
                <td>{{item.batchno}}</td>
                <td>{{item.endtime?item.endtime.split(' ')[0]:''}}</td>
                <td>{{item.certno}}</td>
                <td>{{item.certorg}}</td>
              </tr>
            </table>
          </td>
        </tr>
        <tr class="noborder">
          <td colspan="6" style="height: 10px"></td>
        </tr>
        <tr class="noborder">
          <td align="right">备&nbsp;&nbsp;注：</td>
          <td colspan="5" style="border: none;height: 30px">
            <div style="float: left" v-html="getLiuYan(controlData.remark)">
            </div>
            <div style="float: left;padding-left: 15px" v-for="(item,index) in parameter" v-if="item">
              <span style="min-width:30px;display: inline-block;text-align: right" v-if="index!='备注'&&index!='远近'&&index!='验光师'">{{index+"："}}</span>
              <span style="min-width:30px;display: inline-block;text-align: left;padding-right: 10px" v-if="index!='验光师'">{{item}}</span>
            </div>
          </td>
        </tr>
        <tr class="noborder" v-if="isreturnorderEidt">
          <td align="right">处&nbsp;&nbsp;&nbsp;&nbsp;理：</td>
          <td colspan="3">
            <el-input type="textarea" v-model="cangkutuihuoremark" :autosize="{ minRows: 2, maxRows: 2}"/>
          </td>
        </tr>
        <tr class="noborder" v-if="isreturnorderEidt&&status==655&&controlData.sycstagreementDO.status=='待发货'">
          <td colspan="4" style="padding-top: 10px">
            <span>&nbsp;&nbsp;已下单供应商：</span>
            <el-radio-group v-model="form.orderopinion">
              <el-radio :label="1">拦截成功</el-radio>
              <el-radio :label="-1">拦截失败</el-radio>
            </el-radio-group>
          </td>
        </tr>
        <tr class="noborder" style="height:26px">
          <td align="right">导购员：</td>
          <td colspan="4"><div style="float: left;padding-right: 20px">{{controlData.uname||""}}</div>
            <div style="float: left;padding-right: 20px;min-width: 100px">验光师：{{parameter['验光师']||""}}</div>
            <div style="float: left;padding-right: 20px;min-width: 100px">加工师：</div>
            <div style="float: left;">出库：{{controlData.handleoveruname||""}}</div>
          </td>
          <td colspan="2" rowspan="4" v-if="ewmurl&&isprint"><img :src="ewmurl" style="height: 86px;float: right;margin-right: 4px"></td>
        </tr>
        <tr class="noborder" style="height:8px">
          <td colspan="4">&nbsp;</td>
        </tr>
        <tr class="noborder" style="height: 26px;" v-if="!isprint">
          <td align="right">GZ.NO：</td>
          <td>
            <el-input v-model="form.logisticstracknum" size="mini" ref="logisticstracknum" placeholder="请填写跟踪单号"
                      v-if="btn=='填写发货单'&&!isprint"
                      onfocus="this.select()"
                      style="width: 125px"></el-input>
            <span v-if="btn!='填写发货单'||isprint">{{form.logisticstracknum}}</span>
          </td>
          <td align="right">GY.NO：</td>
          <td colspan="3" v-if="controlData.tracknum">
            <a @click="showSupplyOrder()" style="cursor: pointer;color: dodgerblue"
               v-if="controlData.tracknum&&controlData.tracknum.length>=14&&controlData.tracknum.substr(0,2)=='42'">{{controlData.tracknum}}</a>
            <a v-else>{{controlData.tracknum}}</a>
          </td>
          <td v-else colspan="3">
            <el-input v-model="form.tracknum" size="mini" ref="tracknum" placeholder="请填写供应商单号"
                      v-if="btn=='填写发货单'&&!isprint"
                      onfocus="this.select()"
                      style="width: 125px"></el-input>
          </td>
        </tr>
        <tr class="noborder" style="height:26px">
          <td align="right">门&nbsp;&nbsp;店：</td>
          <!--<td v-if="isNoshow" colspan="3">{{pagetitle.indexOf(';')!=-1?pagetitle.split(';')[0]:pagetitle}}</td>-->
          <td colspan="5"><div style="float: left;padding-right: 30px">{{controlData.applybydname}}&nbsp; &nbsp; &nbsp;{{(controlData.elinkmantel||"")}}</div>
            <div v-if="isprint" style="float: left;">{{printday}}</div></td>
        </tr>
        <tr class="noborder" style="height:26px">
          <td align="right">地&nbsp;&nbsp;址：</td>
          <td colspan="5">{{controlData.address}}</td>
        </tr>
        <tr class="noborder" style="min-height:26px" v-if="isprint&&islaoxian">
          <td colspan="6">
            <div style="float:left;width:100%;padding-top:10px">
              <div style="float:left;width:40%;"><div style="float:left;width:100%; font-size: 14px; font-weight: bolder; "><b>配镜五大免费服务</b></div>
                <div style="float:left;width:100%;"><img width="90%" src="https://lxpj.eyes.wang/loginimg/fuwu.png"></div></div>
              <div style="float:left;width:60%;"><div style="float:left;width:100%; font-size: 14px; font-weight: bolder; ">售后服务</div>
                <div style="float:left;width:100%;font-size: 9pt;line-height:18px">1、取镜之日起6个月内,镜架出现非人为损坏的性能问题,顾客到门店确认后可免费更换同型号色号或同价值的眼镜。<br>2、取镜之日起30天内,镜片出现非人为损坏而产生的镜片脱膜情况,应当免费给顾客更换同品牌同类型材质的镜片。<br>3、取镜之日起30天内,因本公司验光度数引起无法佩戴的情况,应当免费给顾客更换同品牌同类型材质的镜片。</div>
              </div></div>
          </td>
        </tr>
      </table>

      <!--展示已成交中的退货订单信息-->

      <div style="textAlign:center;fontSize:18px;lineHeight:40px;margin-top: 2px;color: red" v-if="isycjorder">
        退货单
      </div>
      <div style="border:1px solid red;width: 640px;padding-left: 15px" v-if="isycjorder">
        <table v-for="(item,indextable) in this.tuihuoorders"
               style="border-collapse:collapse;width:620px;margin-top: 20px">
          <tr class="noborder">
            <td align="left" width="10%">销售单号：</td>
            <td align="left" width="20%">{{item.erpserial}}</td>
            <td align="left" width="10%">下单日期：</td>
            <td align="left">{{item.adddate}}</td>
            <!--<td align="left" width="80">应交付日期：</td>-->
            <!--<td align="left">{{item.jhjgrq}}</td>-->
          </tr>
          <tr>
            <td colspan="6" style="border:none">
              <table cellspacing="0" cellpadding="0" border="0"
                     style="border-collapse:collapse;width:100%;fontSize:'18px'"
                     class="query-table">
                <tr>
                  <td v-if="item !='seedcode' && item !='unitguid'" style="text-align: center"
                      v-for="item in item['tuihuocolumn']">
                    {{item}}
                  </td>
                </tr>
                <tr v-for="(item,index) in item['billmap']" style="cursor:pointer;">
                  <td
                    :style="{textAlign:ob['产品名称']?'left':'center',minWidth:ob['产品名称']?'150px':''}"
                    v-for="(ob,index) in item" v-if="index!=0">
                    <span v-for="value in ob" v-if="index!=0">{{value}}</span>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr class="noborder">
            <td>说&nbsp;&nbsp;&nbsp;&nbsp;明：</td>
            <td colspan="5" style="text-align: left">
              <div v-html="getLiuYan(item.remark)"></div>
            </td>
          </tr>
          <tr v-if="indextable != tuihuoorders.length-1">
            <td colspan="6">
              <div id=content style="border:1px dashed #334455;width: 100%"></div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div slot="footer" class="dialog-footer no-print">
      <el-button @click="dialogSeeVisible = false" size="mini">取 消</el-button>
      <el-button @click="showYangd" type="success" plain size="mini">验光单</el-button>
      <el-button @click="inputBatch" type="success" plain v-if="showyinxing&&(btn=='填写发货单'||status==500||status==400)" size="mini">批次号</el-button>
      <el-button type="primary" @click="saveReturnOrder" v-if="isreturnorderEidt" :loading="loading">确认</el-button>
      <!--订单岗退货确认-->
      <!--<el-button type="success" @click.once="pickingUp" class="qrbtn" v-if="btn=='填写发货单'&&btnvisible&&false">拣货完成-->
      <!--</el-button>-->
      <el-button type="primary" @click="delivergoods" class="qrbtn" v-if="btn=='填写发货单'" :loading="loading">确认发货</el-button>
      <!--<el-select v-model="form.eliverydStatus" placeholder="请选择" style="width: 100px"-->
                 <!--v-if="isZongBu() &&btn=='填写发货单'">-->
        <!--<el-option-->
          <!--v-for="item in options"-->
          <!--:key="item.value"-->
          <!--:label="item.label"-->
          <!--:value="item.value">-->
        <!--</el-option>-->
      <!--</el-select>-->
      <el-button type="info" @click="print1(false)" v-if="!isreturnorderEidt" size="mini">打印</el-button>
      <el-button type="info" @click="print1(true)" v-if="!isreturnorderEidt" size="mini">打印加工单</el-button>
      <span v-if="!isreturnorderEidt" @click="printloglook" style="position: absolute;bottom: 8px;right: 10px">{{tips()}}</span>
      <span v-if="!isreturnorderEidt" @click="handleloglook"
            style="position: absolute;bottom: 25px;right: 10px">(处理日志)</span>
    </div>
    <CstagreementEditSeedDetail ref="seeddetail" @shuxiprint="shuxiprint"></CstagreementEditSeedDetail>
    <UpdateAddress ref="UpdateAddress" @afertupdate="afertupdate"></UpdateAddress>
    <StoreEdit ref="StoreEdit" @afertupdatecangku="afertupdatecangku"></StoreEdit>
    <printlogList ref="printlogList"></printlogList>
    <HandlelogList ref="HandlelogList"></HandlelogList>
    <Printtitle ref="Printtitle" @printtitlename="printtitlename"></Printtitle>
    <BuyfromList ref="BuyfromList"></BuyfromList>
    <ScanCodeBatch ref="ScanCodeBatch" @scancodeedit="scancodeloadBatch" @clearscancode="scancodeloadBatch"></ScanCodeBatch>
    <showGlassessell ref="showGlassessell1" :hidOrder="true"></showGlassessell>
  </el-dialog>
</template>


<script>
  import {
    printing,
    jxcstorelist,
    returnGoodsUpdate,
    ispsq,
    multipleShipments,
    pickingUp,
    checkprinting
  } from '@/api/set/csagreement';
  import jsbarcode from 'jsbarcode'
  import showGlassessell from '@/components/testorder/cstagreement/showGlassessell';
  import CstagreementEditSeedDetail from './CstagreementEditSeedDetail'
  import Printtitle from './Printtitle'
  import UpdateAddress from './UpdateAddress'
  import printlogList from './printlogList'
  import HandlelogList from './HandlelogList'
  import {getRemark, getKHRemark} from '@/plugin/ordercommon'
  import BuyfromList from '@/components/testorder/buyagreement/BuyfromList'
  import {getParameterDetail} from '@/api/set/parameter';
  import {saveOutboundDataNew} from '@/api/set/warehouse';
  import {cusandptbyind} from '@/api/set/jxcstore';
  import {save} from '@/api/order/printlog';
  import StoreEdit from './StoreEdit';
  import {saveData, getListData} from '@/api/set/handlelog';
  import {exportExcel} from '@/api/file';
  import {isLaoxian,checkModuleRight} from '@/api/login'
  import ScanCodeBatch from '@/components/testorder/cstagreement/ScanCodeBatch';
  import {getDetail, batchSave,listBarchno, weiyimalist as storebarcodelistData} from '@/api/set/jxcstoregoodsbarcode';
  import {goodsar} from '@/api/set/jxcgoodsbarcode';

  export default {
    name: 'CstagreementEdit',
    data() {
      return {
        loading:false,
        pagetitle: '',
        printday: '',
        paymethod:'',
        ismachineprint:false,
        clickmachineprint:false,
        ewmurl:'',
        showyinxing:false,
        imgpath: '',
        pageinit:{},
        jiagongimgpath: '',//加工单条形码
        userInfoModel: {},
        columnarr:[{name:'球镜',show:false},{name:'柱镜',show:false},{name:'轴位',show:false},{name:'矫正',show:false},{name:'ADD',show:false},{name:'通道',show:false},{name:'棱镜',show:false},{name:'基底',show:false}],
        flage: true,
        dialogSeeVisible: false,
        formLabelWidth: '120px',
        isprint: false,
        islaoxian:false,
        groupguid: '',
        seedcode: "",
        tableData: [],
        tableShowData: [],
        printData: [],//打印日志
        uname: '',//最新一条打印人员
        adddate: '',//最新一条打印时间
        unitguid: "",
        remark: "",
        remarkselection: '',
        cangkutuihuoremark: '',
        column: [],
        tuihuocolumn: [],
        controlData: {
          sycstagreementDO: {}, cstagreementDOList: []
        },
        showtitle1: "none",
        parameterData: [],
        isshowyuandd: false,
        isreturnorderEidt: false,
        deliveryaddress: '',
        tuihuoyy: [],
        tuihuoorders: [],
        isycjorder: false,
        remarktype: '',
        buyinfo: {},
        //发货方式
        options: [{
          value: '500',
          label: '直发客户'
        }, {
          value: '400',
          label: '发服务中心'
        }],
        isShowAdressAndCangkuUpdate: true,
        logisticsnumPre: '',
        logisticsnumEnd: '',
        form: {
          erpserial: "",
          groupguid:"",
          deliverymode: 10,
          logisticsco: '',
          logisticsnum: '',
          customername: '',
          jxcformdetaillist: '',
          customerserial: '',
          independentserial: '',
          cangkucode: '',
          cangkuname: '',
          origionstatus: '',
          jxcformDetailDo: '',
          isdistribute: '',
          formtype: '',
          orderopinion: '',
          eliverydStatus: '',
          storegoodsbarcode: '',//库存商品唯一条码
          logisticstracknum: '',//跟踪单号
          tracknum:'',
          invoicesource: 0,
          scancodes: [],//仓库发货扫唯一码
        },
        formLabelWidth: '120px',
        jxcstoreData: [],
        priceSuminfo:'',
        parameter: {},
        btn: '',
        status: '',
        totalnumber: 0,
        totalmoney: 0,
        salemoney:0,
        storescan: '',//是否支持扫码出入库
        goodsbar: [],
        caiGouRukuData: [],//出库条码
        storebarcode: [],//所有库存唯一条码
        goodsbarcode: '',//商品条码
        handlelogData: [],//处理日期
        drawer: '',//开单人
        printDisplay: true,//打印是否显示价格
        roletype: '',//岗位类型
        isNoshow: false,//是否需要更换服务商
        goodsDetail:[],
      }
    },
    methods: {
      showYangd(row) {
        this.$refs.showGlassessell1.show({groupguid: this.controlData.sellorderguid, showyg: 1});
      },
      picture() {
        if (this.controlData.isreturnorder && this.controlData.isreturnorder == -1) {
          return {
            width: '100%',
            background: 'url(/static/img/tuihuotip.png) no-repeat right center'
          }
        }
        return {
          width: '100%'
        }
      },
      inputBatch() {
        this.$refs.ScanCodeBatch.show({
            issale: true,
            cangkucode: this.controlData.cangkucode,
            groupguid: this.controlData.groupguid,
            billmap: this.goodsDetail,
            status: this.controlData.status,
            buyerpserial: (this.buyinfo && this.buyinfo.erpserial) ? this.buyinfo.erpserial : ''
          },
          this.form.scancodes, this.btn == '填写发货单', this.showyinxing);
      },
      showSupplyOrder() {//显示供应商系统中的订单
        this.$refs.BuyfromList.show(this.controlData.tracknum, this.controlData.pcustomerserial);
      },
      getMapValue(ol, col) {
        var ret = '';
        for (let j = 0; j < ol.length; j++) {
          if (ol[j].hasOwnProperty(col))
            ret = ol[j][col];
        }
        return ret;
      },
      setMapValue(ol, col, val) {
        var hasV = false;
        for (let j = 0; j < ol.length; j++) {
          if (ol[j].hasOwnProperty(col)) {
            hasV = true
            ol[j][col] = val;
          }
        }
        if (!hasV)
          ol.push({col: val});
      },
      //唯一码扫码数量
      scancodeloadBatch(scancodes) {
        this.form.scancodes = scancodes;
      },
      isZongBu() {//只有总部人员能操作
        return this.userInfoModel.independentserial == null || this.userInfoModel.independentserial == ""
      },
      //查看处理日志
      handleloglook() {
        this.$refs.HandlelogList.show()
        this.$refs.HandlelogList.initData(this.form.groupguid);
      },
      //处理日志
      handlelog() {
        var handlelog = {}

        handlelog.erpserial = this.form.erpserial
        handlelog.groupguid = this.form.groupguid
        handlelog.isopen = 1
        if (this.btn == '填写发货单') {
          handlelog.casestepname = '已发货'
          handlelog.remark = '已从' + this.form.cangkuname + '发给' + this.controlData.customername + '(物流:' + this.form.logisticsco + ',物流单号:' + this.form.logisticsnum + ')'
        } else if (this.status == '655') {
          handlelog.casestepname = '仓库待收货'
          handlelog.remark = '仓库待收货'
        } else if (this.status == '650') {
          handlelog.casestepname = '等待订单岗确认'
          handlelog.remark = '等待订单岗确认'
        } else if (this.status == '660') {
          handlelog.casestepname = '等待财务退款'
          handlelog.remark = '等待财务退款'
        }
        saveData(handlelog).then(response => {
        })
      },
      getCangkuNameByCode(cangkucode) {
        for (let i in this.jxcstoreData) {
          if (this.jxcstoreData[i].cangkucode == cangkucode) {
            return this.jxcstoreData[i].cangkuname
          }
        }
      },
      afertupdate(address, linkman, linkmantel) {
        this.controlData.deliveryaddress = address
        this.controlData.linkman = linkman
        this.controlData.linkmantel = linkmantel
      },
      formatTime() {
        var data = new Date();
        var year = data.getFullYear();
        var month = data.getMonth() + 1;
        var day = data.getDate();
        var hour = data.getHours();
        var minute = data.getMinutes();
        var second = data.getSeconds();
        return year + '-' + month + '-' + day + " " + hour + ":" + minute;
      },
      getTitle(showname) {

        let result = [];
        if (showname && showname != '') {
          if (showname.indexOf(';') != -1) {
            var obj = showname.split(';')
            for (let i in obj) {
              if (obj[i] && i == 0) {
                result = obj[i]
              } else if (obj[i]) {
                result += ';' + obj[i]
              }
            }
          } else {
            result = showname
          }
        } else {
          let temp = localStorage.getItem("hpapi_userInfoModel")
          if (temp) {
            result += JSON.parse(temp).tenantname || ""
          }
        }
        if(this.$route.query.bimanage) {
          result = this.controlData.applybydname;
        }
        if (result.indexOf(';') != -1) {
          var obj = result.split(';')
          for (let i in obj) {
            if (obj[i]) {
              if (this.controlData.voucherdetailguid) {
                obj[i] += "铺货单"
              } else {
                obj[i] += "销售单"
              }
              if (this.isshowyuandd) {
                obj[i] += "(退货单)"
              }
            }
          }
          result = obj.join(';')
        } else {
          if (this.controlData.voucherdetailguid) {
            result += "铺货单"
          } else {
            result += "销售单"
          }
          if (this.isshowyuandd) {
            result += "(退货单)"
          }
        }
        return result
      },
      changereturntype(val) {
        for (let i in this.tuihuoyy) {
          if (this.tuihuoyy[i].value == val) {
            this.remarktype = this.tuihuoyy[i].name
          }
        }
      },

      showDetail(item) {
      },

      shuxiprint() {
        checkprinting({erpserial: this.form.erpserial}).then(response => {
          var printD = response.data.obj.rows;
          this.uname = printD[0].uname;
          this.adddate = printD[0].adddate;
          this.tips()
        })
      },
      //打印
      print1(ismachine) {
        this.clickmachineprint = ismachine ? true : false;

        if (this.form.logisticsco.indexOf('顺丰') > -1) {
          this.form.logisticsnum = this.logisticsnumPre + ':' + this.logisticsnumEnd;
        } else {
          this.form.logisticsnum = this.logisticsnumPre;
        }
        checkprinting({erpserial: this.form.groupguid}).then(response => {
          var printD = response.data.obj.rows;
          if (printD.length > 0) {//表示打印过，需要做出提醒
            this.$confirm('该订单“' + printD[0].uname + '”已于' + printD[0].adddate + '打印过，是否继续?', '提示', {
              confirmButtonText: '取消',
              cancelButtonText: '继续打印',
              type: 'error'
            }).then(() => {
            }).catch(() => {
              if (this.pagetitle.indexOf(";") != -1) {
                if (this.userInfoModel.independentserial)
                  this.isNoshow = true
                this.$refs.Printtitle.show(this.pagetitle, false)
              } else {
                this.startprint(false);
              }
            });
          } else {
            if (this.pagetitle.indexOf(";") != -1) {
              if (this.userInfoModel.independentserial)
                this.isNoshow = true
              this.$refs.Printtitle.show(this.pagetitle, true)
            } else {
              this.startprint(true);
            }
          }
        });
      },
      printtitlename(pagetitle, needreflash) {
        this.pagetitle = pagetitle
        this.startprint(needreflash)
      },
      startprint(needreflash) {
        this.printday = '（' + this.formatTime() + '打单）';
        this.showtitle1 = ""
        this.isprint = true
        this.ismachineprint = this.clickmachineprint;
        this.$nextTick(() => {
          this.$print(this.$refs.print1)
          this.showtitle1 = "none"
          this.isprint = false
          this.ismachineprint=false;
          save({
            erpserial: this.form.erpserial,
            groupguid: this.form.groupguid,
            invoicesource: this.form.invoicesource
          }).then(response => {
            if (response.data.code == 0) {
              if (needreflash) {
                this.dialogSeeVisible = false
                this.$emit("bindGrid");//未打印过，刷新父页面
              }
              this.$message({
                message: '生成打印日志',
                type: 'success'
              })
            }
          })
        })
      },
      tips() {
        if (this.uname) {
          return "(打印：" + this.uname + " " + this.adddate + ")"
        } else {
          return "(未打印过)"
        }
      },
      //查看加工单
      lookMachineOrder(row) {
        this.$parent.$refs.machiningedit.initData(row)
        this.$parent.$refs.machiningedit.show()
      },

      //保存退货订单选项
      saveReturnOrder() {
        let jxcformdetails = [];
        for (let i in this.tableData) {
          let jxcformdetail = {
            unitguid: '',
            brokenparts: ''
          };
          let checked = true
          for (let j in this.tableData[i]) {

            if (this.tableData[i][j]["unitguid"]) {
              jxcformdetail.unitguid = this.tableData[i][j]["unitguid"]
            }
            // if (this.tableData[i][j]["是否坏件"]) {
            //   checked = this.tableData[i][j]["是否坏件"].ischecked
            // }
          }
          if (checked) {
            jxcformdetail.brokenparts = -1
          } else {
            jxcformdetail.brokenparts = 1
          }
          jxcformdetails.push(jxcformdetail)
        }
        if (this.form.orderopinion == '' && this.status == 655 && this.controlData.sycstagreementDO.status == '待发货') {
          this.$message({
            message: '请选择供应商回复意见',
            type: 'error'
          })
          this.loading = false;
          return
        }
        this.loading = true;
        returnGoodsUpdate({
          formdetails: JSON.stringify(jxcformdetails),
          cstagreementDO: JSON.stringify({
            erpserial: this.controlData.erpserial,
            returntype: this.controlData.returntype,
            cangkutuihuoremark: this.cangkutuihuoremark,
            remark: this.remark,
            remarktype: this.remarktype,
            orderopinion: this.form.orderopinion,
            hetongserial: this.controlData.sycstagreementDO.erpserial,
          })
        }).then(response => {
          this.loading = false;
          if (response.data.code == 0) {
            this.$message({
              message: '保存成功',
              type: 'success'
            })
            if (this.status == 660) {
            }
            this.handlelog();
            this.dialogSeeVisible = false
            //刷新列表
            this.$emit("bindGrid")
          } else {
            this.$message({
              message: '保存失败',
              type: 'error'
            })
          }
        })
      },
      show(isShowAdressAndCangkuUpdate) {
        if (isShowAdressAndCangkuUpdate == 1) {
          this.isShowAdressAndCangkuUpdate = false
        } else {
          this.isShowAdressAndCangkuUpdate = true
        }
        this.dialogSeeVisible = true;
      },
      contains(item, arr) {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i] == item) {
            return true;
          }
        }
        return false;
      },
      lookDetails(row) {
        this.$parent.lookDetails(row)
      },

      updatecangku(row) {
        this.$refs.StoreEdit.initData(row, -1, 'medium-dialog', 1);
      },

      afertupdatecangku(cangkucode, cangkuname) {
        this.controlData.cangkucode = cangkucode
        this.controlData.cangkuname = cangkuname
      },
      updateaddress() {
        this.$refs.UpdateAddress.show(this.controlData)
      },
      getLiuYan(remark) {
        if (this.isprint) {
          return getKHRemark(remark);
        }
        return getRemark(remark);
      },
      //岗位类型
      yincangdayin(roletype) {
        this.roletype = roletype
      },
      getPatmethod(paymethod) {
        // var method = ['微信', '支付宝', '刷卡', '现金', '赠送'];
        // for (let item in method) {
        //   if (paymethod.indexOf(method[item]) > -1)
        //     return method[item]
        // }
        return paymethod;
      },
      reflashInit() {
        this.initData(this.pageinit.row, this.pageinit.btn, this.pageinit.groupguid, this.pageinit.seedcode)
      },
      initData(row, btn, groupguid, seedcode) {
        this.pageinit.row = row
        this.pageinit.btn = btn
        this.pageinit.groupguid = groupguid
        this.pageinit.seedcode = seedcode
        this.initForm()
        this.flage = false;

        this.status = row.status
        this.btn = btn
        this.form.erpserial = row.erpserial
        //this.imgpath = window.API_ROOT + "/api/avatar/getBarcode?content=" + row.erpserial.split('-')[0]

        if (row.customername) {
          this.form.customername = row.customername
        }
        if (row.logisticsco) {
          this.form.logisticsco = row.logisticsco
        }
        if (row.logisticsnum) {
          this.form.logisticsnum = row.logisticsnum
          if (row.logisticsnum.indexOf(':') > -1) {
            this.logisticsnumPre = row.logisticsnum.split(':')[0];
            this.logisticsnumEnd = row.logisticsnum.split(':')[1];
          } else {
            this.logisticsnumPre = this.form.logisticsnum;
          }
        }
        if (row.cangkucode) {
          this.form.cangkucode = row.cangkucode
        }
        this.groupguid = groupguid
        this.unitguid = row.unitguid
        printing({
          unitguid: row.unitguid,
          erpserial: this.form.erpserial,
          groupguid: this.groupguid,
          seedcode: seedcode
        }).then(response => {
          this.buyinfo = response.data.obj.caigoudan;

          this.$nextTick(() => {
            this.$refs.inputScan.focus();
          })

          var priceSum = response.data.obj.priceSum;
          if(this.controlData.paymethod&&this.controlData.paymethod.indexOf('挂账')>-1) priceSum.yishou=0;
          var qianKuan=parseFloat(priceSum.htje) - parseFloat(priceSum.yishou);
          this.priceSuminfo = "配镜金额：" + priceSum.htje.toFixed(2) + " &nbsp;&nbsp;实收金额：" + priceSum.yishou.toFixed(2);
          if (response.data.obj.sell) {
            var sells = response.data.obj.sell;
            if (sells.points && sells.points != 0) {
              this.priceSuminfo += " &nbsp;&nbsp;使用" + sells.points + "积分抵" + sells.pointsmoney + "元";
            }
            if (sells.groupbuying && (sells.groupbuying > 0 || sells.groupbuying < 0)) {
              this.priceSuminfo = this.priceSuminfo.replace("实收金额", "团购优惠：" + sells.groupbuying.toFixed(2) + " &nbsp;&nbsp;实收金额");
              qianKuan = qianKuan-parseFloat(sells.groupbuying);
            }
          }
          this.priceSuminfo += "  &nbsp;&nbsp;欠款金额：" + qianKuan.toFixed(2) ;

          jsbarcode(
            '#csteditbarcode',
            row.erpserial.split('-')[0],
            {
              height: 20,
              displayValue: false // 是否在条形码下方显示文字
            }
          )
          //打印日志
          if (response.data.obj.printlogDOList.length > 0) {
            this.printData = response.data.obj.printlogDOList
            this.uname = this.printData[0].uname
            this.adddate = this.printData[0].adddate
          }
          this.controlData = response.data.obj.detail;
          this.paymethod = this.getPatmethod(this.controlData.paymethod);
          this.status = this.controlData.status

          this.form.groupguid = this.controlData.groupguid;
          //确认发货：当天同一个门店的订单公用一个物流号以及物流方式
          if (this.controlData.length != 0) {
            if (this.controlData.logisticsco) {
              this.form.logisticsco = this.controlData.logisticsco
            } else {
              this.form.logisticsco = '自取';//this.parameterData[1].name
            }
            if (this.controlData.logisticsnum) {
              this.form.logisticsnum = this.controlData.logisticsnum
              if (this.controlData.logisticsnum.indexOf(':') > -1) {
                this.logisticsnumPre = this.controlData.logisticsnum.split(':')[0];
                this.logisticsnumEnd = this.controlData.logisticsnum.split(':')[1];
              } else {
                this.logisticsnumPre = this.form.logisticsnum;
              }
            }
          }
          //加工单条形码
          if (this.controlData.machinecstagreementDO)
            this.jiagongimgpath = window.API_ROOT + "/api/avatar/getBarcode?content=" + this.controlData.machinecstagreementDO.erpserial
          this.form.logisticstracknum = this.controlData.logisticstracknum
          this.form.tracknum = this.controlData.tracknum
          //只有总部人员、订单的applybydserial!=''、订单的independentserial==''、订单的deliverymode=配送或自取或内部调拨
          //才可以出现下拉框
          if ((this.isZongBu() && this.controlData.independentserial == null && this.controlData.applybydserial != null &&
            this.controlData.independentserial == "" && this.controlData.applybydserial != "") &&
            (row.deliverymode == '配送' || row.deliverymode == '自取' || row.deliverymode == '内部调拨') && this.controlData.htje >= 0 && this.controlData.formtype == 42) {
            this.form.eliverydStatus = '400'
          }
          // if (this.controlData.yfk == 0) {
          //   this.controlData.sycstagreementDO.paymethod = '按合同结算'
          // }
          if (this.controlData.returntype) {
            let remark = JSON.parse(this.controlData.remark)
            if (this.tuihuoyy) {
              for (let i in this.tuihuoyy) {
                if (this.tuihuoyy[i].value == this.controlData.returntype) {
                  this.remarktype = this.tuihuoyy[i].name
                }
              }
            }

            if (remark[1]) {
              this.remark = remark[1].msg
            }
            this.controlData.returntype = this.controlData.returntype + ''
          } else {
            this.controlData.returntype = this.tuihuoyy[0].value
            this.remarktype = this.tuihuoyy[0].name
          }
          if (this.controlData.sycstagreementDO.unitguid) {
            if (this.controlData.sycstagreementDO.status == "200") {
              this.controlData.sycstagreementDO.status = "待确认"
            } else if (this.controlData.sycstagreementDO.status == "350") {
              this.controlData.sycstagreementDO.status = "待发货"
            } else if (this.controlData.sycstagreementDO.status == "400") {
              this.controlData.sycstagreementDO.status = "待配送"
            } else if (this.controlData.sycstagreementDO.status == "500") {
              this.controlData.sycstagreementDO.status = "已发货"
            }
          }

          this.isshowyuandd = this.controlData.isreturnorder && this.controlData.isreturnorder == 1;
          if (this.isshowyuandd && !this.controlData.sycstagreementDO.erpserial) {
            this.controlData.sycstagreementDO.erpserial = '无'
          }
          this.form.invoicesource = response.data.obj.detail.invoicesource;
          this.goodsDetail = response.data.obj.goodsDetail;
          this.tableData = response.data.obj.goodsDetail;
          this.pagetitle = this.getTitle(response.data.obj.detail.printdname);
          if (this.tableData.length > 0) {
            //取出表头
            let temparr = []
            let biaoji = 0
            for (let i in this.tableData) {
              this.totalnumber += (this.tableData[i]["数量"] || 0)
              this.totalmoney += (this.tableData[i]["总价"] || 0)
              this.salemoney += (this.tableData[i]["单价"] || 0)
              var RL = "";
              var ZhouW = "";
              var JiaoZ = "";
              var ADD = "";
              var tongdao = "";
              var xinghao = "";
              var guige = "";
              var jidi = "";
              var lenjing = "";
              for (let j in this.tableData[i]) {
                if (j == "R/L") {
                  biaoji = 1
                  RL = this.tableData[i][j];
                }
                if (j == "型号") {
                  xinghao = this.tableData[i]["型号"];
                } else if (j == "球镜") {
                  this.flage = true;
                  xinghao = this.tableData[i]["球镜"];
                }
                if (j == "规格") {
                  guige = this.tableData[i]["规格"];
                } else if (j == "柱镜") {
                  this.flage = true;
                  guige = this.tableData[i]["柱镜"];
                } else if (j == "ADD") {
                  ADD = this.tableData[i][j];
                } else if (j == "轴位") {
                  ZhouW = this.tableData[i][j];
                }  else if (j == "矫正") {
                  JiaoZ = this.tableData[i][j];
                } else if (j == "通道") {
                  tongdao = this.tableData[i][j];
                } else if (j == "棱镜") {
                  lenjing = this.tableData[i][j];
                } else if (j == "基底") {
                  jidi = this.tableData[i][j];
                }
              }//球镜/柱镜*轴位，ADD，通道

              var rows = {
                "RL": RL, "球镜": xinghao, "柱镜": guige, "seedcode": this.tableData[i]["seedcode"], "scannum": 0,
                "产品名称": this.tableData[i]["产品名称"], "数量": (this.tableData[i]["数量"] || 0),
                "总价": (this.tableData[i]["总价"] || 0), "单价": (this.tableData[i]["单价"] || 0)
              };
              if (ZhouW && this.flage) {
                for (let j in this.columnarr) {
                  if (this.columnarr[j].name == '轴位')
                    this.columnarr[j].show = true;
                }
                rows["轴位"] = ZhouW;
              }
              if (JiaoZ && this.flage) {
                for (let j in this.columnarr) {
                  if (this.columnarr[j].name == '矫正')
                    this.columnarr[j].show = true;
                }
                rows["矫正"] = JiaoZ;
              }
              if (lenjing && this.flage) {
                for (let j in this.columnarr) {
                  if (this.columnarr[j].name == '棱镜')
                    this.columnarr[j].show = true;
                }
                rows["棱镜"] = lenjing;
              }
              if (jidi && this.flage) {
                for (let j in this.columnarr) {
                  if (this.columnarr[j].name == '基底')
                    this.columnarr[j].show = true;
                }
                rows["基底"] = jidi;
              }
              if (ADD && this.flage) {
                for (let j in this.columnarr) {
                  if (this.columnarr[j].name == 'ADD')
                    this.columnarr[j].show = true;
                }
                rows["ADD"] = ADD;
              }
              if (tongdao && this.flage) {
                for (let j in this.columnarr) {
                  if (this.columnarr[j].name == '通道')
                    this.columnarr[j].show = true;
                }
                rows["通道"] = tongdao;
              }

              this.tableShowData.push(rows);
            }

            if (this.btn && this.btn == 1) {
              this.isreturnorderEidt = true
            } else {
              this.isreturnorderEidt = false
            }

            this.tableData = this.tableData.map(o1 => this.column.map(o2 => {
              let ob = {}
              if (o2 == '发货数量') {
                if (this.storescan || this.form.scancodes.length > 0) {
                  ob[o2] = ''
                } else {
                  ob[o2] = o1["数量"] || 0
                }
              } else
                ob[o2] = o1[o2] || ""
              return ob
            }))
          }
          this.parameter = {}
          var paraCol = response.data.obj.parametercolumn.split(";");
          for (let i in paraCol) {
            if (paraCol[i]) {
              this.parameter[paraCol[i]] = response.data.obj.parameter[paraCol[i]];
            }
          }

          this.showyinxing = response.data.obj.batchbarcode;
          if (this.showyinxing && response.data.obj.detail.status == 500) {//隐形要显示批次号
            listBarchno({
              inordernum: response.data.obj.detail.erpserial,
              groupguid: response.data.obj.detail.groupguid
            }).then(resYX => {
              this.form.scancodes = resYX.data.obj
            });
          }

          //退货单
          this.tuihuoorders = response.data.obj.tuihuoorders
          if (this.tuihuoorders.length > 0) {
            this.isycjorder = true
            if (this.tuihuoorders.length > 0) {
              for (let g = 0; g < this.tuihuoorders.length; g++) {
                //取出表头
                let temparr = []
                let biaoji = 0
                this.tuihuocolumn = []
                for (let i in this.tuihuoorders[g]['billmap']) {
                  for (let j in this.tuihuoorders[g]['billmap'][i]) {
                    if (j == "R/L") {
                      biaoji = 1
                    }
                    if (j != "seedcode" && j != "R/L" && j != "数量" && j != "说明" && j != "产品名称" && j != "球镜" && j != "柱镜" && j != "轴位" && j != "矫正" && !this.contains(j, temparr) && j != "销售单号" && j != "本次采购数量" && j != "unitguid" && j != "单价" && j != "总价") {
                      temparr.push(j)
                    }
                  }
                }
                //对表头排序
                this.tuihuocolumn.push("seedcode")
                if (biaoji == 1) {
                  this.tuihuocolumn.push("R/L")
                }
                this.tuihuocolumn.push("产品名称")
                this.tuihuocolumn.push("数量")
                this.tuihuocolumn.push("单价")
                this.tuihuocolumn.push("总价")

                this.tuihuoorders[g]['tuihuocolumn'] = this.tuihuocolumn
                this.tuihuoorders[g]['billmap'] = this.tuihuoorders[g]['billmap'].map(o1 => this.tuihuocolumn.map(o2 => {
                  let ob = {}
                  ob[o2] = o1[o2]
                  return ob
                }))
              }
            }
          }

          if (row.openprint) {
            this.print1(false);
          }
        });
      },
      printloglook() {
        this.$refs.printlogList.show()
        this.$refs.printlogList.initData(this.form.groupguid);
      },
      //封装表头
      tablesoret(temparr, biaoji, column, table) {

      },
      showError(errorinfo) {
        this.$message({
          message: errorinfo,
          type: 'error'
        })
      },

      delivergoods() {
        if ((this.form.logisticsco.indexOf('快递') > -1 || this.form.logisticsco.indexOf('顺丰') > -1) && !this.logisticsnumPre) {
          this.showError('请填写快递单号！')
          this.loading = false;
          return;
        }
        if (this.form.logisticsco.indexOf('顺丰') > -1) {
          if (!this.logisticsnumEnd) {
            this.showError('请输入寄件人手机号后4位')
            this.loading = false;
            return
          }
          this.form.logisticsnum = this.logisticsnumPre + ':' + this.logisticsnumEnd;
          localStorage.setItem("hpapi_sendexpressmobile", this.logisticsnumEnd);
        } else {
          this.form.logisticsnum = this.logisticsnumPre;
        }
        // if (JSON.parse(localStorage.getItem("hpapi_parames")).other.oddrequired == 'true') {
        //   if (!this.form.logisticstracknum) {
        //     this.showError('请输入跟踪单号！')
        //     this.loading = false;
        //     return
        //   }
        // }

        if (this.showyinxing && this.form.scancodes.length == 0) {
          this.showError('请填写隐形批次号！')
          this.loading = false;
          return
          // this.$confirm('请选择隐形批次号，是否继续发货？', '提示', {
          //   confirmButtonText: '继续发货',
          //   cancelButtonText: '选批次号',
          //   type: 'warning'
          // }).then(() => {
          //   this.afterDeliverGoods();
          // }).catch(() => {
          //   this.loading = false;
          // });
        } else {
          this.afterDeliverGoods();
        }
      },
      afterDeliverGoods() {
        for (let i = 0; i < this.jxcstoreData.length; i++) {
          if (this.jxcstoreData[i].cangkucode == this.form.cangkucode) {
            this.form.cangkuname = this.jxcstoreData[i].cangkuname
            break
          }
        }
        if (this.showyinxing && this.form.scancodes && this.form.scancodes.length > 0) {
          for (let i in this.showyinxing) {//商品、订单对应表
            for (let j in this.form.scancodes) {
              if (this.form.scancodes[j].seedcode == this.showyinxing[i].seedcode) {
                this.form.scancodes[j].erpserial = this.showyinxing[i].customerserial;
              }
            }
          }
          this.form.scancodes = JSON.stringify(this.form.scancodes);
        }
        else
          this.form.scancodes = null;

        this.form.formtype = 72
        if (this.form.logisticstracknum)
          this.form.logisticstracknum = this.form.logisticstracknum.trim()
        this.loading = true;
        multipleShipments(this.form).then(response => {
          this.loading = false;
            if (response.data.code == 0) {
              if (response.data.neworder) {
                this.form.erpserial = response.data.neworder.erpserial
                this.$message({
                  message: '操作成功，新的单号：' + this.form.erpserial,
                  type: 'success'
                })
                this.initData(response.data.neworder)
              } else {
                this.$message({
                  message: response.data.msg,
                  type: 'success'
                })
                this.dialogSeeVisible = false
              }
              this.handlelog();
              //刷新列表
              this.$emit("cutItemAfterHandle", this.form.groupguid)
            } else {
              this.$message({
                message: response.data.msg,
                type: 'error'
              })
            }
          }
        );
      },
      //保存仓库货品条形码关系表
      saveBarCodeData() {
        batchSave({caiGouRukuData: JSON.stringify(this.caiGouRukuData), erpbarcodes: null}
        ).then(response => {

        })
      },

      selectbarcode() {//商品光度码
        if (!this.goodsbarcode)
          return;

        var obj = {
          barcode: this.goodsbarcode
        }
        this.goodsbarcode = '';
        goodsar(obj).then(response => {
          this.goodsbar = response.data.obj
          if (response.data.code == 1 || !this.goodsbar || !this.goodsbar.packagesize) {
            this.$message({message: '条码无效！', type: 'error'})
            return
          }
          var hasV = false;
          var pg = JSON.parse(this.goodsbar.packagesize);
          if (!pg.X) {
            this.$message({message: '条码无效！', type: 'error'})
            return
          }
          var X = pg.X;
          var Y = pg.Y;
          for (let i in this.tableShowData) {
            var row = this.tableShowData[i];
            if (row.seedcode == this.goodsbar.seedcode && row['柱镜'] == X && row['球镜'] == Y) {
              if (row['scannum'] < row['数量']) {
                row['scannum'] += 1;
                hasV = true;
                this.$message({message: '匹配成功！', type: 'success'})
                break;
              }
            }
          }
          if (!hasV) {
            this.$message({message: '条码匹配失败！', type: 'error'})
          }
        })
      },
      initForm() {
        if (this.$refs.form1 != undefined) {
          this.$refs.form1.resetFields();
        }
        for (let i in this.columnarr) {
          if (this.columnarr[i].name == '球镜' || this.columnarr[i].name == '柱镜')
            this.columnarr[i].show = true;
          else
            this.columnarr[i].show = false;
        }
        this.handlelogData = []
        this.tableShowData = []
        this.drawer = ''
        this.form.storegoodsbarcode = ''
        this.groupguid = ""
        this.column = []
        this.tableData = []
        this.unitguid = ""
        this.totalmoney = 0
        this.salemoney = 0;
        this.totalnumber = 0
        this.isycjorder = false
        this.logisticsnumPre = '';
        this.logisticsnumEnd = localStorage.getItem("hpapi_sendexpressmobile");
        if (this.logisticsnumEnd == null)
          this.logisticsnumEnd = '';
        this.form.logisticsnum = ''
        this.form.logisticsco = ''
        this.form.isdistribute = ""
        this.form.cangkucode = ""
        this.form.cangkuname = ""
        this.form.erpserial = ""
        this.form.deliverymode = 10
        this.form.customername = ''
        this.form.customerserial = ''
        this.form.independentserial = ''
        this.form.origionstatus = ''
        this.form.jxcformDetailDo = ''
        this.form.formtype = ''
        this.form.orderopinion = ''
        this.form.eliverydStatus = ''
        this.uname = ''
        this.adddate = ''
        this.flage = true
        this.goodsbarcode = ''
        this.form.logisticstracknum = ''
        this.form.tracknum = ''
        this.remark = ""
        this.remarkselection = ""
        this.cangkutuihuoremark = ""
        this.form.scancodes = []
      }
    },
    computed: {
      fahuonumber() {
        let s = 0
        this.tableData.forEach(o => {
          o.forEach(o2 => {
            if (typeof o2["发货数量"] != 'undefined') {
              s += parseInt(o2["发货数量"] || 0)
            }
          })
        })
        return s
      }
    },
    mounted() {
      //是否支持扫码出入库
      checkModuleRight({name: 'storescan'}).then(reponse => {
        this.storescan = reponse.data.code == 0;
      });
      this.islaoxian=isLaoxian();
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"));
      var tenantList = JSON.parse(localStorage.getItem("hpapi_tokenModel")).tenantDO;
      for (let i in tenantList) {
        if (tenantList[i].unitguid == this.userInfoModel.tenantid) {
          this.ewmurl = tenantList[i].ewmurl;
          break;
        }
      }
      getParameterDetail({paraname: "快递公司"}).then(response => {
        var parac = response.data.obj?response.data.obj.paracontent:null;
        if (!parac) parac = '[{"name":"自取","value":"10"}]';
        var paracontent = JSON.parse(parac);

        for (let i = 0; i < paracontent.length; i++) {
          var obj = {
            name: '', value: ''
          }
          obj.name = paracontent[i].name
          obj.value = paracontent[i].name
          this.parameterData.push(obj)
        }
      });
      getParameterDetail({paraname: "退货原因"}).then(response => {
        var parac = response.data.obj?response.data.obj.paracontent:null;
        if (!parac) parac = "[{\"name\":\"下错订单\",\"unitguid\":\"\",\"value\":\"10\"},{\"name\":\"商品损坏\",\"unitguid\":\"\",\"value\":\"20\"},{\"name\":\"等不及取消订单\",\"unitguid\":\"\",\"value\":\"30\"},{\"name\":\"质量有问题\",\"unitguid\":\"\",\"value\":\"40\"},{\"name\":\"发错货\",\"unitguid\":\"\",\"value\":\"50\"},{\"name\":\"发货超期退单\",\"unitguid\":\"\",\"value\":\"60\"},{\"name\":\"其他\",\"unitguid\":\"\",\"value\":\"99\"}]";
        this.tuihuoyy = JSON.parse(parac);
      });
      cusandptbyind().then(response => {
        this.jxcstoreData = response.data.obj
        if (this.jxcstoreData.length > 0)
          this.form.cangkucode = this.jxcstoreData[0].cangkucode
      })
    },
    components: {
      CstagreementEditSeedDetail,
      UpdateAddress,
      printlogList,
      StoreEdit,
      HandlelogList,
      Printtitle,
      BuyfromList,
      ScanCodeBatch,
      showGlassessell
    },
  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }


</style>



// WEBPACK FOOTER //
// src/components/testorder/cstagreement/CstagreementEdit.vue